export default "__VITE_ASSET__d85d8e66__"